var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"clock"},[_c('span',{staticClass:"time"},[_vm._v(" "+_vm._s(_setup.currentTime)+" ")]),_c('span',{staticClass:"date"},[_vm._v(" "+_vm._s(_setup.currentDate)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }